
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classic/[id]",
      function () {
        return require("private-next-pages/classic/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classic/[id]"])
      });
    }
  